import { render, staticRenderFns } from "./FakeSendMailModal.vue?vue&type=template&id=19a95ca9&scoped=true"
import script from "./FakeSendMailModal.vue?vue&type=script&lang=js"
export * from "./FakeSendMailModal.vue?vue&type=script&lang=js"
import style0 from "./FakeSendMailModal.vue?vue&type=style&index=0&id=19a95ca9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a95ca9",
  null
  
)

export default component.exports